import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { MenuHighlights } from '../components/MenuHighlights';
import { ChefQuote } from '../components/ChefQuote';
import { HoursLocation } from '../components/HoursLocation';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-279" />
      <About data-id="element-280" />
      <MenuHighlights data-id="element-281" />
      <ChefQuote data-id="element-282" />
      <HoursLocation data-id="element-283" />
      <Contact data-id="element-284" />
    </>;
}